export const GA_TRACKING_ID = "G-NJVZ9B8D6P";

export const gtag = (...args) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(args);
};

export const pageview = (url) => {
  gtag("config", GA_TRACKING_ID, {
    page_path: url,
  });
};
